import { useEffect, useState } from 'react';
import { useEstabsContext } from '../../../../contexts/EstabsContext';
import { urlFile } from '../../../../AxiosConfig';
import { useFormHorarioClienteContext } from './Context';
import { Building2, ChevronRight } from 'lucide-react';

const EstabRow = ({ item, onSelect }: { item: any; onSelect: () => void }) => {
    const [imageFailed, setImageFailed] = useState(false);

    return (
        <li className="border-b border-base-content/[0.08] last:border-b-0">
            <button type="button" className="flex min-h-[4rem] w-full items-center gap-3 px-4 py-3 text-left active:bg-base-content/5" onClick={onSelect}>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-base-200 text-base-content/40">
                    {item?.imageId && !imageFailed ? (
                        <img src={`${urlFile}/${item.imageId}`} alt="" className="h-full w-full object-contain" onError={() => setImageFailed(true)} />
                    ) : (
                        <Building2 aria-hidden="true" />
                    )}
                </span>
                <span className="min-w-0 flex-1 font-medium text-base-content">{item?.name}</span>
                <ChevronRight className="text-xs text-base-content/30" aria-hidden="true" />
            </button>
        </li>
    );
};

export const SelectEstab = () => {
    const { estabsUser } = useEstabsContext();
    const { setEstab } = useFormHorarioClienteContext();
    const estabs = (estabsUser as any[]).filter(({ type }) => type === 'client');

    useEffect(() => {
        if (estabs.length === 1) setEstab(estabs[0]);
    }, [estabsUser]);

    return (
        <ul className="overflow-hidden rounded-2xl bg-base-100 ring-1 ring-base-content/[0.06]">
            {estabs.map((item: any) => (
                <EstabRow key={item?._id} item={item} onSelect={() => setEstab(item)} />
            ))}
        </ul>
    );
};
